import script from "./ComparativoSeccion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparativoSeccion.vue?vue&type=script&setup=true&lang=ts"

import "./ComparativoSeccion.vue?vue&type=style&index=0&id=27ed6e0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ed6e0a"]])

export default __exports__